import Other from "./Other";

function OtherForm(props) {
  const {
    changeShowOtherFormBool,
    changeHideOtherFormBool,
    showOtherForm,
  } = props;

  const employeeForm = (values) => {
    props.addForm({
      employee_or_guest: "employee",
      ...values,
    });
  };

  return (
    <div className="witness_form_container">
      <div className="witness_form">
        <div className="witness_form_title">Others</div>
      </div>
      <Other
        employeeForm={employeeForm}
        changeShowOtherFormBool={changeShowOtherFormBool}
        changeHideOtherFormBool={changeHideOtherFormBool}
        showOtherForm={showOtherForm}
        selectedDetail={props.selectedDetail}
        totalForms={props.totalForms}
        mainSaveButton={props.mainSaveButton}
        showNotiPage={props.showNotiPage}
        overViewValues={props.overViewValues}
        paramPendingBool={props.paramPendingBool}
        changedValue={props.changedValue}
        customModalForConfirmCancel={props.customModalForConfirmCancel}
        newAddedSignature={props.newAddedSignature}
        setNewAddedSignature={props.setNewAddedSignature}
      />
    </div>
  );
}

export default OtherForm;
